import React from 'react';
import style from './style.module.scss';

type Props = {
  title: string;
};

const SectionTitle = ({ title }: Props) => {
    return (
        <h5 className={style.sectionTitle}>{title}</h5>
    );
}

export default SectionTitle;